<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :value="displayValue"
        :label="label"
        readonly
        clearable
        outlined
        dense
        hide-details
        v-bind="attrs"
        v-on="on"
        @click:clear="clearRange"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="rangeDates"
      range
      :locale="$store.state.user.lang"
      :max="new Date().toISOString().substr(0, 10)"
      min="1950-01-01"
      color="primary"
      @change="onRangeChange"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api'

export default {
  name: 'DateRangePickerCustom',

  props: {
    dateFrom: {
      type: String,
      default: null,
    },
    dateTo: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Période',
    },
  },

  setup(props, { emit }) {
    const menu = ref(false)
    const rangeDates = ref([])

    const syncRangeFromProps = () => {
      const dates = [props.dateFrom, props.dateTo].filter(Boolean)

      rangeDates.value = dates.length ? [...dates].sort() : []
    }

    const displayValue = computed(() => {
      if (props.dateFrom && props.dateTo) {
        return `${props.dateFrom} — ${props.dateTo}`
      }

      if (props.dateFrom) {
        return props.dateFrom
      }

      return ''
    })

    const emitRange = dates => {
      const sorted = [...(dates || [])].filter(Boolean).sort()

      emit('change', {
        dateFrom: sorted[0] || null,
        dateTo: sorted[1] || null,
      })
    }

    const onRangeChange = dates => {
      emitRange(dates)

      if (Array.isArray(dates) && dates.length === 2) {
        menu.value = false
      }
    }

    const clearRange = () => {
      rangeDates.value = []
      emit('change', { dateFrom: null, dateTo: null })
    }

    watch(() => [props.dateFrom, props.dateTo], syncRangeFromProps, { immediate: true })

    return {
      menu,
      rangeDates,
      displayValue,
      onRangeChange,
      clearRange,
    }
  },
}
</script>
